import { apiRequest } from './api';

// Saved filter presets — shared by Dashboard and Position Summary.
// Source of truth is the server (user_preferences table, key
// 'filter_presets') so presets follow the user across devices; localStorage
// is kept as an offline cache and as the migration source on first load.
const LS_KEY = 'stocksummary_saved_filters';
const PREF_KEY = 'filter_presets';

export const readLocalPresets = () => {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY) || '{}');
  } catch {
    return {};
  }
};

export async function loadFilterPresets() {
  const local = readLocalPresets();
  try {
    const resp = await apiRequest(`/api/preferences/${PREF_KEY}`);
    const server = resp.data?.value;
    if (server && typeof server === 'object' && Object.keys(server).length > 0) {
      try { localStorage.setItem(LS_KEY, JSON.stringify(server)); } catch {}
      return server;
    }
    // Nothing stored server-side yet — migrate existing local presets up
    if (Object.keys(local).length > 0) {
      persistFilterPresets(local);
    }
    return local;
  } catch {
    return local;
  }
}

export function persistFilterPresets(presets) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(presets)); } catch {}
  apiRequest(`/api/preferences/${PREF_KEY}`, {
    method: 'PUT',
    body: JSON.stringify({ value: presets }),
  }).catch(() => {});
}
